import React from "react";
import { PageHeader } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import RecurringForm from "./form";

export default function RecurringCreate() {
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Recurring", path: "/billing/recurring" },
          { label: "Create", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <SyncOutlined /> }}
        title="New Recurring Template"
        style={{ marginBottom: 16 }}
      />
      <RecurringForm />
    </div>
  );
}
